/**
 * Configuração central dos KPIs que suportam histórico mensal.
 * Cada entrada define:
 * - key: testid ou ID interno
 * - label: título humano
 * - Icon: componente lucide
 * - color: cor semântica da métrica (hex, usado no chart/sparkline)
 * - getValue(monthObj): extrai o número mensal
 * - format(v): formata para exibição (número atual, tooltip, cards)
 * - formatDelta(v): formata a diferença (ex: "1.2", "5%", "3h")
 * - lowerIsBetter: true = subir é ruim (semântica das setas)
 */
import { Star, Share2, TrendingUp, Clock, AlertTriangle, MessageSquare } from 'lucide-react';

export const KPI_METRICS = {
  rating: {
    key: 'rating',
    label: 'Média Geral',
    Icon: Star,
    color: '#C5A059',
    getValue: (m) => Number(m.avg_rating || 0),
    format: (v) => `${Number(v).toFixed(1)}/5`,
    formatDelta: (v) => Number(v).toFixed(1),
    lowerIsBetter: false,
  },
  google: {
    key: 'google',
    label: 'Convidados ao Google',
    Icon: Share2,
    color: '#10B981',
    getValue: (m) => Number(m.convidados_google_pct || 0),
    format: (v) => `${Math.round(Number(v))}%`,
    formatDelta: (v) => `${Math.round(Number(v))}%`,
    lowerIsBetter: false,
  },
  satisfaction: {
    key: 'satisfaction',
    label: 'Satisfação',
    Icon: TrendingUp,
    color: '#10B981',
    getValue: (m) => Number(m.satisfacao_pct || 0),
    format: (v) => `${Math.round(Number(v))}%`,
    formatDelta: (v) => `${Math.round(Number(v))}%`,
    lowerIsBetter: false,
  },
  responseTime: {
    key: 'responseTime',
    label: 'Tempo de Resposta',
    Icon: Clock,
    color: '#3B82F6',
    getValue: (m) => Number(m.tempo_resposta_h || 0),
    format: (v) => (Number(v) > 0 ? `${Number(v).toFixed(1)}h` : '—'),
    formatDelta: (v) => `${Number(v).toFixed(1)}h`,
    lowerIsBetter: true,
  },
  urgent: {
    key: 'urgent',
    label: 'Urgentes',
    Icon: AlertTriangle,
    color: '#EF4444',
    getValue: (m) => Number(m.urgentes || 0),
    format: (v) => `${Math.round(Number(v))}`,
    formatDelta: (v) => `${Math.round(Number(v))}`,
    lowerIsBetter: true,
  },
  complaints: {
    key: 'complaints',
    label: 'Críticas',
    Icon: MessageSquare,
    color: '#EF4444',
    getValue: (m) => Number(m.criticas || 0),
    format: (v) => `${Math.round(Number(v))}`,
    formatDelta: (v) => `${Math.round(Number(v))}`,
    lowerIsBetter: true,
  },
  suggestions: {
    key: 'suggestions',
    label: 'Sugestões',
    Icon: MessageSquare,
    color: '#3B82F6',
    getValue: (m) => Number(m.sugestoes || 0),
    format: (v) => `${Math.round(Number(v))}`,
    formatDelta: (v) => `${Math.round(Number(v))}`,
    lowerIsBetter: false,
  },
  praises: {
    key: 'praises',
    label: 'Elogios',
    Icon: MessageSquare,
    color: '#F59E0B',
    getValue: (m) => Number(m.elogios || 0),
    format: (v) => `${Math.round(Number(v))}`,
    formatDelta: (v) => `${Math.round(Number(v))}`,
    lowerIsBetter: false,
  },
};
